import React, { useState } from "react";
import { Button, Box, Typography, Card, CardContent, CardMedia, LinearProgress, useMediaQuery } from "@mui/material";
import addActiveCourse from "../../learningpath/hooks/AddactiveCourses";
import addActiveProject from "../../learningpath/hooks/AddactiveProjects";
import useLearningProgress from '../../learningpath/hooks/Courseslearnigpath';
import useLearningProjects from '../../learningpath/hooks/projectslearningPath';
import { CertifiedDataScientistCourses } from "./coursesdata";
import { CertifiedDataScientistProjects } from "./projectsData";
import useNetworkStatus from "../../../../../helper/NetworkStatus";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const LearningCard = ({ items, learningProgress }) => {
  const isMobile = useMediaQuery("(max-inline-size:600px)");
  const isTablet = useMediaQuery("(max-inline-size:960px)");

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 3,
        margin: "10px",
        justifyContent: isMobile ? "center" : isTablet ? "space-around" : "flex-start",
      }}
    >
      {items.map((item, index) => {
        const progressData = learningProgress.find(p => p.productId === item.videoUrl);
        const progress = progressData?.productProgress || 0;

        return (
          <Box
            key={`${item.courseId || item.projectId}-${index}`}
            sx={{ flexBasis: isMobile ? '100%' : isTablet ? '45%' : '228px', minWidth : '200px' }}
            //onClick={() => addActiveItem(item.courseTitle || item.projectTitle, item.videoUrl, category)}
          >
            <Card sx={{ display: 'flex', flexDirection: 'column', height : '100%' }}>
              <Box sx={{ position: 'relative', '&:hover .description-overlay': { opacity: 1 } }}>
                <CardMedia
                  component="img"
                  sx={{ height : 160, objectFit: 'cover' }}
                  image={item.image}
                  alt={item.courseTitle || item.projectTitle}
                />
                <Box
                  className="description-overlay"
                  sx={{
                    position: 'absolute',
                    top : 0,
                    left : 0,
                    width : '100%',
                    height : '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '10px',
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out',
                  }}
                >
                  <Typography variant="body2" sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                    {item.courseTitle || item.projectTitle}
                  </Typography>
                </Box>
              </Box>

              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  variant="body1"
                  sx={{
                    paddingBottom : 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {index + 1}. {item.courseTitle || item.projectTitle}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom : 2 }}>
                  <Typography variant="body2" sx={{ marginRight : 2 }}>
                    {Math.min(progress, 100).toFixed(0)}%
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      flexGrow: 1,
                      height : "8px",
                      backgroundColor: "#E0E0E0",
                    }}
                  />
                </Box>

                {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  {progress === 100 ? (
                    <Button variant="contained" color="success">Completed</Button>
                  ) : progress >= 1 ? (
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: 'blue',
                        color: 'white',
                        borderColor: 'blue',
                        '&:hover': {
                          backgroundColor: 'darkblue',
                          borderColor: 'darkblue',
                        },
                      }}
                    >
                      Resume
                    </Button>
                  ) : (
                    <Button variant="outlined">Start</Button>
                  )}
                </Box> */}
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#9b9b9b",
                      color: "#ffff",
                    }}
                  >
                    Coming Soon
                  </Button>
              </CardContent>
            </Card>
          </Box>
        );
      })}
    </Box>
  );
};

const Courses = () => {
  const [, setMessage] = useState(null);
  const category = "DATA SCIENCE";
  const learningProgress = useLearningProgress(category);
  const { isOnline } = useNetworkStatus();

  return (
    <Box sx={{ padding: "10px 10px 10px 20px" }}>
      {isOnline ? (
        <LearningCard
          items={CertifiedDataScientistCourses[0].courses}
          type="course"
          category={category}
          addActiveItem={(title, url, cat) => addActiveCourse(title, url, cat, setMessage)}
          learningProgress={learningProgress}
        />
      ) : (
        <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
      )}
    </Box>
  );
};

const Projects = () => {
  const [, setMessage] = useState(null);
  const category = "DATA SCIENCE";
  const learningProgress = useLearningProjects(category);
  const { isOnline } = useNetworkStatus();

  return (
    <Box sx={{ padding: "10px 10px 10px 20px" }}>
      {isOnline ? (
        <LearningCard
          items={CertifiedDataScientistProjects[0].projects}
          type="project"
          category={category}
          addActiveItem={(title, url, cat) => addActiveProject(title, url, cat, setMessage)}
          learningProgress={learningProgress}
        />
      ) : (
        <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
      )}
    </Box>
  );
};

export { Courses, Projects };
